import React from "react";

import {
  makeStyles,
  useTheme,
  Grid,
  Paper,
  useMediaQuery,
  Button,
  ListItemText,
  List,
  ListItem,
  Typography,
  AppBar,
  CssBaseline
} from "@material-ui/core";
import agcLogo from "./images/SIP_template.png";
import sipAbacusLogo from "./images/sip-academy-logo1.png";
import plusLeft from "./images/plusSignLeft.svg";
import plusRight from "./images/plusSignRight.svg";
import agcDoll from "./images/DOLL_P4.svg";
import backgroudImage from "./images/BG_Page_04.svg";
import mobileBG from "./images/mobileBG.svg";
//import backgroudImage2022 from "./images/BG_Page_2022.png";
import backgroudImage2022 from "./images/BG_2022_AGC.jpg";
import agc2023mobileLogo from "./images/Bg_2023_mobile.png";
import agc2023WebLogo from "./images/Bg_2023_web.png";
import agc2024mobileLogo from "./images/Bg_2024_mobile.png";
import agc2024WebLogo from "./images/Bg_2024_web.png";
import agc2025WebLogo from "./images/Plain_Background.png";
import agc2025logo from "./images/AGC Logo 2025.png";
import title2025 from "./images/Title_Template.png";

const useStyles = makeStyles(theme => ({
  aboutAGCRoot: {
    backgroundColor: "white",
    alignContent: "stretch",
    flexWrap: "nowrap",
    height: "100%",
    width: "100%"
  },
  aboutAGCPaper: {
    width: "180%",
    height: "125vh",
    backgroundImage: `url(${agc2025WebLogo})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
  },
  aboutAGCTitle: {
    textAlign: "center",
    fontSize: theme.spacing(4),
    color: "white",
    fontWeight: "bold",
    marginTop: "80px"
  },
  aboutAGCContent: {
    textAlign: "left",
    fontSize: theme.spacing(3),
    color: "#fafafa",
    marginTop: theme.spacing(2),
    whiteSpace: "pre-line"
  },
  aboutAGCBox: {
    border: "4px solid #E62127",
    borderRadius: "4px",
    padding: "3px 5px",
    textAlign: "center",
    shadowColor: "#F5E740",
    shadowOffset: {
      width: 0,
      height: 12
    },
    shadowOpacity: 0.58,
    shadowRadius: 16.0,
    whiteSpace: "pre-line",
    //color: "black",
    fontWeight: "bold",
    fontSize: "16px"
  },
  secondTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "white",
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(4)
  },
  mobileWorkFlowPaper: {
    width: "100%",
    height: "auto",
    backgroundImage: `url(${agc2025WebLogo})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
  },
  registrationPageLink: {
    textDecoration: "none"
  },

  button: {
    color: "white",
    backgroundColor: "#E62127",
    fontWeight: "bold",
    borderRadius: theme.spacing(1),
    display: "inline-block",
    textAlign: "center"
  },
  title: {
    textAlign: "center",
    color: "white",
    backgroundColor: "#E62127",
    fontWeight: "bold",
    borderRadius: "15px",
    height: "85%",
    whiteSpace: "pre-line",
    display: "inline-block",
    fontSize: theme.spacing(2),
    padding: theme.spacing(3)
  },
  agcText: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#000000"
  }
}));

const AGCWorkFlow = () => {
  const classes = useStyles();
  let theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const title = "About Arithmetic Genius Contest - 2025";
  const register = "SAMPLE QUESTION PAPER";

  function Content() {
    if (smallScreen) {
      return (
        <React.Fragment>
          <Grid item container>
            <Grid item xs={1}></Grid>
            <Grid item xs={10} style={{ textAlign: "left" }}>
              <div className={classes.aboutAGCBox}>
                <Typography className={classes.agcText}>
                  Who can participate ?{" "}
                </Typography>
              </div>
              <List style={{ textAlign: "justify" }}>
                <ListItem>
                  <ListItemText>
                    <Typography className={classes.agcText}>
                      Students from Classes 1 to 5
                    </Typography>
                  </ListItemText>
                </ListItem>
              </List>

              <div className={classes.aboutAGCBox}>
                <Typography className={classes.agcText}>
                  School-Level Rounds(June - Sept 2025)
                </Typography>
              </div>
              <List>
                <ListItem>
                  <ListItemText>
                    <Typography className={classes.agcText}>
                      Top 30% per class qualify for Round 2.
                    </Typography>
                  </ListItemText>
                </ListItem>
              </List>

              <div className={classes.aboutAGCBox}>
                <Typography className={classes.agcText}>
                  State-Level Finals (Oct – Nov 2025){" "}
                </Typography>
              </div>
              <List>
                <ListItem>
                  <ListItemText>
                    <Typography className={classes.agcText}>
                      Top 5 per class (25 per school) reach this stage
                    </Typography>
                  </ListItemText>
                </ListItem>
              </List>
              <div className={classes.aboutAGCBox}>
                <Typography className={classes.agcText}>
                  National Finals (Dec 2025)
                </Typography>
              </div>
              <List>
                <ListItem>
                  <ListItemText>
                    <Typography className={classes.agcText}>
                      One topper per class from each state qualifies.
                    </Typography>
                  </ListItemText>
                </ListItem>
              </List>
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid
              container
              xs={12}
              sm={12}
              justifyContent="flex-end"
              alignItems="flex-end"
            >
              {/*<img src={agcDoll} alt="doll" />*/}
            </Grid>
          </Grid>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <Grid container>
            <Grid item md={3} lg={3}>
              {/* <img src={agcDoll} alt="doll"  style={{ marginTop:theme.spacing(23),backgroundSize: "cover"}}/> */}
            </Grid>
            <Grid item md={6} lg={6}>
              <Grid item container justify="center" spacing={4}>
                <Grid item md={5} lg={5}>
                  <div className={classes.aboutAGCBox}>
                    <Typography className={classes.agcText}>
                      Who can participate ?{" "}
                    </Typography>
                  </div>
                  <List>
                    <ListItem>
                      <ListItemText>
                        <Typography className={classes.agcText}>
                          Students from
                          <b>&nbsp;Classes 1 to 5. </b>
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Grid>
                <Grid item md={6} lg={6} style={{ textAlign: "center" }}>
                  <div className={classes.aboutAGCBox}>
                    <Typography className={classes.agcText}>
                      School-Level Rounds(June - Sept 2025)
                    </Typography>
                  </div>
                  <List>
                    <ListItem>
                      <ListItemText>
                        <Typography className={classes.agcText}>
                          Top 30% per class qualify for Round 2.
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={3} lg={3}></Grid>
          </Grid>
          <Grid container>
            <Grid item md={3} lg={3}>
              {/* <img src={agcDoll} alt="doll"  style={{ marginTop:theme.spacing(23),backgroundSize: "cover"}}/> */}
            </Grid>
            <Grid item md={6} lg={6}>
              <Grid item container justify="center" spacing={4}>
                <Grid item md={5} lg={5}>
                  <div className={classes.aboutAGCBox}>
                    <Typography className={classes.agcText}>
                      State-Level Finals (Oct – Nov 2025){" "}
                    </Typography>
                  </div>
                  <List>
                    <ListItem>
                      <ListItemText>
                        <Typography className={classes.agcText}>
                          Top 5 per class (25 per school) reach this stage
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Grid>
                <Grid item md={6} lg={6} style={{ textAlign: "center" }}>
                  <div className={classes.aboutAGCBox}>
                    <Typography className={classes.agcText}>
                      National Finals (Dec 2025)
                    </Typography>
                  </div>
                  <List>
                    <ListItem>
                      <ListItemText>
                        <Typography className={classes.agcText}>
                          One topper per class from each state qualifies.
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={3} lg={3}></Grid>
          </Grid>
        </React.Fragment>
      );
    }
  }

  return (
    <React.Fragment>
      <CssBaseline />
      <Grid container justifyContent="center" alignItems="center">
        <Paper
          className={
            smallScreen ? classes.mobileWorkFlowPaper : classes.aboutAGCPaper
          }
        >
          <Grid item container md={12} xs={12} lg={12} sm={12} xl={12}>
            <AppBar position="static" style={{ backgroundColor: "#E62127" }}>
              <Grid item md={3} xs={3} lg={3} sm={3} xl={3}></Grid>
              <Grid item md={4} xs={9} sm={9} lg={4} xl={4}>
                <img
                  src={sipAbacusLogo}
                  alt="logo"
                  height={smallScreen ? "60%" : "60%"}
                  width={smallScreen ? "60%" : "50%"}
                />
              </Grid>
              <Grid item md={5} xs={0} sm={0} lg={5} xl={5}></Grid>
            </AppBar>
          </Grid>

          <Grid item container>
            <Grid item xs={12}>
              <div
                style={{
                  position: "relative",
                  width: "100vw",
                  height: "200px"
                }}
              >
                <img
                  src={agc2025logo}
                  style={{
                    position: "absolute",
                    top: smallScreen ? "30px" : "80px",
                    left: smallScreen ? "40px" : "150px",
                    width: smallScreen ? "80px" : "200px",
                    height: smallScreen ? "80px" : "200px",
                    zIndex: 2
                  }}
                />
                <img
                  src={agcLogo}
                  alt="Logo"
                  style={{
                    width: "100%",
                    height: smallScreen ? "80px" : "200px",
                    display: "block"
                  }}
                />
              </div>
            </Grid>
            <Grid item md={6} xs={1} sm={1} lg={6} xl={6}></Grid>

            <Grid item md={3} xs={6} sm={6} lg={3} xl={6}>
              {smallScreen ? (
                ""
              ) : (
                <div>
                  <br></br>
                  <br></br>
                  <br></br>
                </div>
              )}
              <Grid item container style={{ marginTop: theme.spacing(3) }}>
                <Grid item container style={{ marginTop: theme.spacing(3) }}>
                  <Grid
                    item
                    md={3}
                    xs={2}
                    sm={2}
                    lg={3}
                    xl={3}
                    alignContent="flex-end"
                  ></Grid>
                  <Grid item md={6} xs={8} sm={8} lg={6} xl={6}>
                    <a
                      href="#sampleQuestionPaper"
                      className={classes.registrationPageLink}
                    >
                      <Button
                        style={{
                          top: smallScreen ? "-160px" : "450px",
                          width: "100%",
                          left: smallScreen ? "180px" : "-200px",
                          fontSize: smallScreen ? "10px" : "14px"
                        }}
                        variant="contained"
                        className={classes.button}
                      >
                        {register}
                      </Button>
                    </a>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            container
            md={12}
            xs={12}
            lg={12}
            sm={12}
            xl={12}
            style={{
              marginTop: smallScreen ? -theme.spacing(16) : theme.spacing(5),
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative"
            }}
          >
            <img
              src={title2025}
              style={{
                width: smallScreen ? "90vw" : "600px",
                height: smallScreen ? "70px" : "100px",
                position: "absolute",
                top: smallScreen ? "-20px" : "-110px"
              }}
            />
            <Typography
              style={{
                position: "absolute",
                color: "white",
                fontWeight: "bold",
                fontSize: smallScreen ? "16px" : "25px",
                textAlign: "center",
                width: "80%",
                top: smallScreen ? "10px" : "-60px",
                transform: "translateY(-50%)"
              }}
            >
              {title}
            </Typography>
          </Grid>

          <br />
          <br />
          <br />
          <Content></Content>
        </Paper>
      </Grid>
    </React.Fragment>
  );
};

export default AGCWorkFlow;
